import PRODUCT_TYPES from './ProductTypes';


export default {
    REWARDS: 'rewards',
    LOW_INTEREST: PRODUCT_TYPES.LOW_INTEREST,
    BALANCE_TRANSFER: PRODUCT_TYPES.BALANCE_TRANSFER,
    SECURED: PRODUCT_TYPES.SECURED,
};
